import { WebhookOutlinedIcon } from 'tuui';
import CommonCollapsibleCard from 'components/CommonCollapsibleCard/CommonCollapsibleCard';
import { SectionHeader } from 'modules/campaigns/components';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { SubscriptionAccountField } from '../SubscriptionAccountField/SubscriptionAccountField';
import { SubscriptionNameField } from '../SubscriptionNameField/SubscriptionNameField';
import { SubscriptionUserIdField } from '../SubscriptionUserIdField/SubscriptionUserIdField';
import styles from './subscriptionInitializeSection.module.scss';

export const SubscriptionInitializeSection = () => {
    return (
        <CommonCollapsibleCard
            id="SUBSCRIPTION_INITIALIZE"
            header={
                <SectionHeader
                    headerIcon={<WebhookOutlinedIcon />}
                    headerText={
                        <FormattedMessage
                            id="push-api.subscription.creator.setup.step.title"
                            defaultMessage="Subscription Setup"
                        />
                    }
                />
            }
            containerClassName={styles['card-container']}
        >
            <div className={styles['col-list']}>
                <SubscriptionNameField />
                <SubscriptionAccountField />
                <SubscriptionUserIdField />
            </div>
        </CommonCollapsibleCard>
    );
};
